import {
  MFA_STA,
  SET_PWD,
  LOGIN,
} from '../../dataProvider/constant';

export const getNextSignInPath = ({
  status,
  authType,
  hasSessionToken,
  hasAccessToken,
  hasIdToken,
  postLoginRedirectPath,
}) => {
  if (!status) {
    return '';
  }

  if (authType === MFA_STA && hasSessionToken) {
    return '/signin_code';
  }

  if (authType === SET_PWD && hasSessionToken) {
    return '/signup';
  }

  if (authType === LOGIN && hasAccessToken && hasIdToken) {
    return postLoginRedirectPath;
  }

  return '';
};

export const isSignInSubmitDisabled = ({ count, fromChild, isSubmitting }) => {
  if (isSubmitting) {
    return true;
  }

  return count > 2 && fromChild !== 'Verified';
};
